/**
 * Versões vigentes dos documentos legais exibidos ao usuário.
 *
 * Espelha `functions/utils/legalDocs.js` da isugar-api. O front manda a versão
 * que de fato exibiu; o back grava essa versão junto com o aceite. É o que
 * permite demonstrar, anos depois, qual texto a pessoa leu — sem isso, uma
 * cláusula invocada contra um usuário sancionado não se prova vigente na data
 * do fato.
 *
 * Ao publicar nova versão de qualquer documento, atualize `version` aqui E no
 * arquivo correspondente da API, com o mesmo valor.
 */

export const LEGAL_DOCUMENTS = {
  terms: {
    id: "termos-de-uso",
    version: "2026-08-11",
    url: "https://isugar.com.br/termos-de-uso.html",
    label: "Termos de Uso",
  },
  privacy: {
    id: "politica-de-privacidade",
    version: "2026-08-11",
    url: "https://isugar.com.br/politica-de-privacidade.html",
    label: "Política de Privacidade",
  },
};

export const TERMS_URL = LEGAL_DOCUMENTS.terms.url;
export const PRIVACY_URL = LEGAL_DOCUMENTS.privacy.url;
export const TERMS_VERSION = LEGAL_DOCUMENTS.terms.version;
export const PRIVACY_VERSION = LEGAL_DOCUMENTS.privacy.version;
